import { put } from "redux-saga/effects";
import {
  ADD_PAYMENT,
  AddPaymentProperties,
  NEW_PAYMENT_METHOD_ADDED,
  NewPaymentMethodAddedProperties,
  PaymentVerifyResult,
  PaymentVerifyResultEnum,
} from "redmond";
import { actions } from "../actions";
import { verifyPaymentMethod } from "../../../api/v1/payment-methods/verifyPaymentMethod";
import { trackEvent } from "../../../api/v1/analytics/trackEvent";
import { addTrackingProperties } from "../../../context/experiments";

export function* verifyPaymentMethodSaga({
  payload,
  isVCN,
}: actions.IVerifyPaymentMethod) {
  try {
    const result: PaymentVerifyResult = yield verifyPaymentMethod(payload);
    switch (result.PaymentVerifyResult) {
      case PaymentVerifyResultEnum.CardDeclined:
        yield put(
          actions.verifyPaymentMethodCallStateFailed(result.PaymentVerifyResult)
        );
        break;
      case PaymentVerifyResultEnum.ExcessiveUserActivity:
        yield put(
          actions.verifyPaymentMethodCallStateFailed(result.PaymentVerifyResult)
        );
        break;
      case PaymentVerifyResultEnum.GenericError:
        yield put(
          actions.verifyPaymentMethodCallStateFailed(result.PaymentVerifyResult)
        );
        break;
      case PaymentVerifyResultEnum.Success:
        yield put(actions.verifyPaymentMethodCallStateSuccess());
        yield put(actions.listPaymentMethods());

        trackEvent({
          eventName: ADD_PAYMENT,
          properties: {
            success: true,
            is_vcn: isVCN,
          },
        });

        trackEvent({
          eventName: NEW_PAYMENT_METHOD_ADDED,
          properties: addTrackingProperties(undefined, {
            entry_type: "customer_profile",
          } as NewPaymentMethodAddedProperties),
        });
        return;

      default:
        yield put(
          actions.verifyPaymentMethodCallStateFailed(result.PaymentVerifyResult)
        );
        break;
    }
    trackEvent({
      eventName: ADD_PAYMENT,
      properties: {
        success: false,
        is_vcn: isVCN,
      },
    });
  } catch (e) {
    const properties: AddPaymentProperties = {
      success: false,
      is_vcn: isVCN,
    };
    trackEvent({
      eventName: ADD_PAYMENT,
      properties,
    });
    yield put(
      actions.verifyPaymentMethodCallStateFailed(
        PaymentVerifyResultEnum.GenericError
      )
    );
  }
}
